import React, { useEffect, createElement } from 'react';
import { DashboardLayout } from './components/layout/DashboardLayout';
export function App() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <DashboardLayout data-id="element-0" />;
}